import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { request } from '../../../../services/request';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { Namespace } from '@wix/ambassador-legends-persona-v1-chat/types';
import { getPersonaChat } from '@wix/ambassador-legends-persona-v1-chat/http';

export default async function (flowAPI: ControllerFlowAPI, chatId: string) {
  try {
    const chat = (
      await request({
        flowAPI,
        options: getPersonaChat({
          chatId,
          namespace: Namespace.EDUCATION,
        }),
        errorOptions: {
          errorCodesMap: { applicationError: {} },
        },
      })
    )?.data?.chat;

    flowAPI.controllerConfig.setProps({
      chat,
    });
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'GetPersonaChat',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });
  }
}
